export enum ActiveGameButtonType {
  TAKE_SEAT = 'TAKE_SEAT',
  UNREGISTER = 'UNREGISTER'
}

export enum SpinGameVariant {
  HOLDEM = 'HOLDEM',
  HOLDEM_FLASH = 'HOLDEM_FLASH',
  HOLDEM_MAX = 'HOLDEM_MAX',
  HOLDEM_SIX = 'HOLDEM_6',
  OMAHA = 'OMAHA'
}

export enum ActiveGameType {
  Cash = 'Cash',
  SAG = 'SAG',
  Tourney = 'Tourney',
  Zoom = 'Zoom'
}

export interface ActiveGameDataShared {
  id: string;
  type: ActiveGameType;
  buttonType: ActiveGameButtonType;
}

export interface ActiveGameDataSAG extends ActiveGameDataShared {
  name: string;
  gameVariant: SpinGameVariant | string;
  type: ActiveGameType.SAG;
  buyIn: string;
}

export interface ActiveGameDataTourney extends ActiveGameDataShared {
  startTime: number;
  name: string;
  type: ActiveGameType.Tourney;
}

export interface ActiveGameDataCash extends ActiveGameDataShared {
  name: string;
  gameFormat: string;
  type: ActiveGameType.Cash | ActiveGameType.Zoom;
}

export type ActiveGameData = ActiveGameDataSAG | ActiveGameDataTourney | ActiveGameDataCash;
